<template>
  <div class="main">
    <div class="back" @click="backBtn">
      <i></i>
      <span>返回</span>
    </div>
    <div class="content_view">
      <div class="title">
        <p>创建任务</p>
        <div></div>
      </div>
      <ul class="content">
        <li v-for="(item, index) in menuList" :key="index">
          <p>{{ item.title }}任务</p>
          <div class="hande">
            <el-button class="el-icon-plus" @click="addTypeTask(item)">{{
              item.title
            }}</el-button>
            <p v-if="item.dataListArr.length">
              已添加{{ item.dataListArr.length }}项
            </p>
          </div>
          <template v-if="item.dataListArr.length">
            <el-table
              :data="item.dataListArr"
              height="250"
              border
              style="width: 100%"
            >
              <el-table-column
                prop="itemName"
                :label="item.title.slice(2, 4) + '名称'"
              >
              </el-table-column>
              <el-table-column
                prop="IsPublish"
                :label="item.title.slice(2, 4) + '状态'"
              >
              </el-table-column>
              <el-table-column
                prop="address"
                label="操作"
                align="center"
                width="160px"
              >
                <template slot-scope="scope">
                  <div class="operation_box">
                    <el-button
                      type="text"
                      size="small"
                      @click="editTask(scope.row, item)"
                      >{{ btnTxt(scope.row, item) }}</el-button
                    >
                    <el-button
                      v-if="scope.row.IsPublish !== '考试中'"
                      type="text"
                      size="small"
                      @click="deleteTask(scope.row, item, index)"
                      >移除</el-button
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </li>
      </ul>
      <div class="button_view">
        <div>
          <!-- <el-button type="primary" @click="cutcoms(1)">上一步</el-button> -->
          <el-button type="primary" @click="nextStep">下一步</el-button>
        </div>
      </div>
    </div>
    <!-- 弹出框 -->
    <div class="exam_dialog">
      <el-dialog title="考试时间设置" :visible.sync="dialogVisible" width="42%">
        <div>
          <div class="bacle_input">
            <h5>考试时间：</h5>
            <div class="examTimeSelect">
              <el-date-picker
                :readonly="true"
                v-model="timeSelect"
                value-format="yyyy-MM-dd HH:mm"
                class="standard_input"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="bacle_input">
            <h5>答题时长：</h5>
            <el-input
              v-model="timeValue"
              maxlength="3"
              :readonly="true"
              placeholder="不应低于10分钟"
              class="standard_input"
            ></el-input>
            <p>分钟</p>
          </div>
          <div class="flex_pwd" v-if="examInfo.cheat_pwd">
            <p v-if="examInfo.cheat_pwd && examInfo.cheat_pwd != 'null'">
              手机考生防作弊：{{ examInfo.cheat_pwd }}
            </p>
            <p v-if="examInfo.facePsw && examInfo.facePsw != 'null'">
              监考员认证码：{{ examInfo.facePsw }}
            </p>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
          <el-button type="primary" @click="dialogVisible = false"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import training from "@/api/trainingApi";
export default {
  data() {
    return {
      dialogVisible: false,
      menuList: [
        {
          ID: 1,
          path: "Papers",
          title: "创建考试",
          label: "考试",
          begainTime: "",
          endTime: "",
          type: "exam",
          dataListArr: [],
        },
        {
          ID: 2,
          path: "Testpapers",
          title: "创建练习",
          label: "练习",
          type: "exercise",
          dataListArr: [],
        },
        {
          ID: 3,
          path: "Resources",
          title: "创建课件",
          label: "课件",
          type: "courseware",
          dataListArr: [],
        },
        {
          ID: 4,
          path: "videoresources",
          title: "创建视频",
          label: "视频",
          type: "video",
          dataListArr: [],
        },
      ],
      deleteArr: [],
      timeSelect: [],
      timeValue: "",
      examInfo: "", // 考试的信息
    };
  },
  props: ["cutcoms"],
  methods: {
    // 返回按键
    backBtn() {
      this.cutcoms(0);
      this.$router.push("manage");
      this.$destroy();
    },
    addTypeTask(item) {
      // sessionStorage.setItem('isTraining',true) // 是否培训过来的

      // 考试
      this.$router.push({
        path: item.path,
        query: {
          trainId: this.$parent.examRow.tranid || this.$route.query.trainId,
          state: 0,
          type: item.type,
        },
      });
    },
    // 获取列表
    getTraininInfo() {
      this.$nextTick(async () => {
        const obj = {
          trainId: this.$parent.examRow.tranid || this.$route.query.trainId, // 此处跳转ID丢失路由回传取ID
        };
        console.log(obj);
        const { data } = await training.getTrainByID(obj);
        if (data.Status == 200) {
          this.menuList[0].dataListArr = this.filterDeleteData(
            data.Data.trainContent.examArr,
            "考试"
          );
          this.menuList[0].begainTime = this.$moment(
            data.Data.trainInfo.begainTime
          ).format("YYYY-MM-DD");
          this.menuList[0].endTime = this.$moment(
            data.Data.trainInfo.endTime
          ).format("YYYY-MM-DD");
          this.menuList[1].dataListArr = this.filterDeleteData(
            data.Data.trainContent.excerciseArr,
            "练习"
          );
          this.menuList[2].dataListArr = this.filterDeleteData(
            data.Data.trainContent.courseArr,
            "课件"
          );
          this.menuList[3].dataListArr = this.filterDeleteData(
            data.Data.trainContent.videoArr,
            "视频"
          );
          this.$parent.passScore = data.Data.trainInfo.passScore; // 回显
        } else {
          this.$message.error(data.Data);
        }
      });
    },
    // 过滤掉假删数据
    filterDeleteData(arr, name) {
      const oldDeleteArr = JSON.parse(sessionStorage.getItem("deleteArr"));
      var timestamp = new Date().getTime();
      arr = arr.map((item) => {
        item.typeName = name;
        console.log(name,'name');
        if (timestamp < new Date(item.itemBeginTime).getTime()) {
          item.IsPublish = name !== "考试" ? "未开放" : "待考试";
        } else if (
          timestamp > new Date(item.itemBeginTime).getTime() &&
          timestamp < new Date(item.itemEndTime).getTime()
        ) {
          item.IsPublish = name !== "考试" ? "开放中" : "考试中";
        } else {
          item.IsPublish = name !== "考试" ? "已结束" : "考试结束";
        }
        return item;
      });
      if (oldDeleteArr) {
        return arr.filter((item) => {
          if (oldDeleteArr.includes(item.scoreId) !== true) {
            return item.scoreId;
          }
        });
      } else {
        return arr;
      }
    },
    // 编辑
    async editTask(row, item) {
      if (
        (item.ID == 1 && row.IsPublish !== "待考试") ||
        (item.ID == 2 && row.IsPublish !== "待练习")
      ) {
        const obj = {
          scoreId: row.scoreId,
          type: row.type,
          typeId: row.typeId,
        };
        const { data } = await training.getTypeDetail(obj);
        if (data.Status == 200) {
          this.dialogVisible = true;
          console.log(data);
          this.examInfo = data.Data;
          this.timeSelect[0] = this.$moment(data.Data.BeginTime).format(
            "YYYY-MM-DD HH:mm:ss"
          );
          this.timeSelect[1] = this.$moment(data.Data.EndTime).format(
            "YYYY-MM-DD HH:mm:ss"
          );
          this.timeValue = data.Data.SpendTime;
        } else {
          this.$message.error(data.Data);
        }
        return;
      }
      this.$router.push({
        path: item.path,
        query: {
          trainId: row.trainId,
          typeId: row.typeId,
          state: 1,
          type: row.type,
          scoreId: row.scoreId,
        },
      });
    },
    // 删除
    deleteTask(row, item, index) {
      // 此处删除为假删,缓存到最后一步才去提交
      console.log(row, item, index);
      this.$confirm(
        `此操作将永久删除该${item.title.slice(2, 4)}, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          if (this.deleteArr.includes(row.scoreId) == false) {
            this.deleteArr.push(row.scoreId);
            this.menuList[item.ID - 1].dataListArr = this.menuList[
              item.ID - 1
            ].dataListArr.filter((item) => {
              return item.scoreId != row.scoreId;
            });
          }
          //   this.$message({
          //     type: "success",
          //     message: "删除成功!",
          //   });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 下一步
    nextStep() {
      sessionStorage.setItem("deleteArr", JSON.stringify(this.deleteArr));
      if (!sessionStorage.getItem("stateMenuList")) {
        sessionStorage.setItem("stateMenuList", JSON.stringify(this.menuList));
      }
      this.cutcoms(4);
    },
  },
  computed: {
    btnTxt() {
      return function (row, item) {
        if (item.type === "exam") {
          if(row.IsPublish === '考试中' || row.IsPublish === '考试结束'){
            return '查看'
          }else{
            return '编辑'
          }
        } else {
          return "编辑";
        }
      };
    },
  },
  activated() {
    this.getTraininInfo();
  },
};
</script>

<style lang="scss" scoped>
.main {
  box-sizing: border-box;
  background-color: #ffffff;
  width: 100%;
  min-height: 780px;
  //   padding: 24px;
  position: relative;
  .content_view {
    padding: 24px;
  }
  .title {
    display: flex;
    align-items: center;
    > p {
      font-size: 22px;
      margin-right: 24px;
    }
    > div {
      border-bottom: 1px solid #e3e6eb;
      width: 50%;
      height: 1px;
    }
  }
  .content {
    margin-top: 24px;
  }
  ul {
    list-style-type: none;
    li {
      margin-top: 24px;
      > p {
        margin-bottom: 16px;
      }
    }
  }
}
.button_view {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  bottom: 4%;
  // margin-top: 12%;
  > div {
    display: flex;
    padding: 16px;
    > .el-button {
      width: 120px;
      margin-right: 16px;
    }
  }
}
// 返回按键css
.back {
  border-bottom: 1px solid #f8f8f8;
  padding: 10px 0px 9px 24px;
  background-color: #fff;
  height: 44px;
  border-radius: 0px 0px 10px 10px;
  i {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-top: 2px solid #999999;
    border-left: 2px solid #999999;
    transform: scaleY(0.6) rotate(-45deg);
  }
  span {
    cursor: pointer;
    width: 47px;
    height: 25px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}
.hande {
  display: flex;
  align-items: center;
  > .el-button {
    color: #fff;
    background: #0052d9;
    margin-right: 28px;
  }
}
::v-deep .el-table {
  width: 600px !important;
  margin-top: 24px;
}
::v-deep .cell {
  text-align: center;
}
.el-button--text {
  font-size: 16px;
}
::v-deep .el-table__cell {
  padding: 6px 0px !important;
}
.exam_dialog {
  ::v-deep .el-dialog__header {
    height: 55px;
    background: linear-gradient(
      180deg,
      #64b5ff 0%,
      rgba(199, 228, 255, 1) 100%
    );
    opacity: 1;
    border-radius: 5px 5px 0px 0px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
  }
  ::v-deep .el-dialog__wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  ::v-deep .el-dialog {
    min-width: 460px !important;
    // min-height: 280px !important;
    border-radius: 5px 5px 0px 0px;
  }
  ::v-deep .dialog-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    .el-button {
      &:nth-child(2) {
        margin-left: 24px;
      }
    }
  }
}
.bacle_input {
  display: flex;
  padding-right: 40px;
  .examTimeSelect {
    ::v-deep .el-date-editor {
      width: 550px;
    }
    margin-bottom: 30px;
  }
  ::v-deep .el-input {
    width: 550px;
  }
  h5 {
    display: inline-block;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    text-align: left;
    line-height: 40px;
    padding-left: 20px;
    &::before {
      content: "*";
      width: 20px;
      display: inline-block;
      color: #ff0000;
    }
  }
  p {
    margin-left: 10px;
    line-height: 40px;
    text-align: center;
  }
}
.flex_pwd {
  > p {
    font-size: 16px;
    text-align: center;
    margin-top: 12px;
  }
}
</style>